export default "__VITE_ASSET__BGmftJX6__"